import { USER_STORAGE_IDENTIFIER } from '@/modules/userStorage';

export const BONUS_SEEN_IDENTIFIER =
  USER_STORAGE_IDENTIFIER.BONUSES_LAST_SEEN_AT;

export interface IBonusLastSeenInfo {
  /** ISO 8601 timestamp of when the user last opened the My Bonuses tab. */
  lastSeenAt: string;
}
